import EducationPanel from "@/scenes.ui/education-panel";
import {Scene} from "phaser";
import PlayerStore from "@/store/player";
import TextButton from "@/scenes.ui/text-button";
import {Keys} from "@/constants/key";
import SoundUtils from "@/utils/sound-utils";

export default class EduWithButton extends Phaser.GameObjects.Container {

    private educationPanel: EducationPanel | undefined;
    private okButton: TextButton | undefined;

    constructor(scene: Scene, teacherKey: string, title: string, text: string, answer: string, buttonClickSound: (Phaser.Sound.BaseSound | undefined), callback: () => unknown) {
        super(scene);

        if (!this.educationPanel) {
            this.educationPanel = new EducationPanel(scene, 0, undefined);
            scene.add.existing(this.educationPanel);
        }
        this.educationPanel!.init(PlayerStore.getPlayer().companionImage, text, () => {
            this.showOkButton(scene, answer, () => {
                if (this.educationPanel) {
                    this.educationPanel!.destroy();
                    this.educationPanel = undefined;
                    SoundUtils.play(buttonClickSound);
                    callback();
                }
            });
        }, () => {
            if (this.okButton) {
                this.okButton.destroy();
                this.okButton = undefined;
            }
            if (this.educationPanel) {
                this.educationPanel!.destroy();
                this.educationPanel = undefined;
                SoundUtils.play(buttonClickSound);
                callback();
            }
        });
    }

    private showOkButton(scene: Scene, buttonText: string, callback: () => unknown): TextButton {
        this.okButton = new TextButton(scene, 410, 210, Keys.GREEN_HORIZONTAL_BUTTON, buttonText);
        this.okButton.setDepth(1001);
        scene.add.existing(this.okButton);
        this.okButton.alpha = 0;

        scene.tweens.chain({
            targets: this.okButton,
            tweens: [
                {},
                {
                    duration: 400,
                    alpha: 1
                }]
        });

        this.okButton.setCallback(() => {
            if (this.okButton) {
                this.okButton!.setVisible(false);
                this.okButton!.destroy();
                this.okButton = undefined;
                callback();
            }
        });

        return this.okButton;
    }

}